import DialogFunctions from "../../../core/dialogFunctions";
import moment from "moment";

class AddHolidayDialogController extends DialogFunctions {
  constructor($mdDialog) {
    "ngInject";

    super($mdDialog);
    this.minDate = moment().add("days", 1);
  }
}

export default AddHolidayDialogController;



// WEBPACK FOOTER //
// ./src/pages/holidays/addHolidayDialog/addHolidayDialog.controller.js